import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // Kullanıcı giriş yapmamışsa, giriş sayfasına yönlendir.
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
